import { Outlet } from 'react-router-dom'

import App from '@/App.tsx'
import { action as createAppointmentAction } from '@/screens/createAppointmentAction.ts'
import { AutomaticBooking } from '@/screens/xpert/AutomaticBooking.tsx'
import { ErrorScreen } from '@/screens/xpert/ErrorScreen'
import { ConfirmBooking } from '@/screens/xpert/ManualBooking/ConfirmBooking'
import {
  loader as selectClinicLoader,
  SelectClinic,
} from '@/screens/xpert/ManualBooking/SelectClinic'
import {
  loader as selectDateTimeLoader,
  SelectDateTime,
} from '@/screens/xpert/ManualBooking/SelectDateTime'
import { MoreInformation } from '@/screens/xpert/MoreInformation'
import { ProtectedRoute } from '@/screens/xpert/ProtectedRoute.tsx'
import { ReferralNotFound } from '@/screens/xpert/ReferralNotFound.tsx'
import { ReferralSelection } from '@/screens/xpert/ReferralSelection.tsx'
import { SuccessScreen } from '@/screens/xpert/SuccessScreen'

import {
  action as bookWithReferralAction,
  BookWithReferral,
  loader as bookWithReferralLoader,
} from '../screens/xpert/BookWithReferral'
import {
  action as confirmDetailsAction,
  ConfirmDetails,
  loader as confirmDetailsLoader,
} from '../screens/xpert/ConfirmDetails'
import {
  loader as proposedAppointmentLoader,
  ProposedAppointment,
} from '../screens/xpert/ProposedAppointment'

export const router = [
  {
    children: [
      {
        element: <ReferralSelection />,
        index: true,
        path: '*',
      },
      {
        children: [
          {
            action: bookWithReferralAction,
            element: <BookWithReferral />,
            loader: bookWithReferralLoader,
            path: 'book',
          },
          {
            action: confirmDetailsAction,
            element: (
              <ProtectedRoute requireReferral>
                <ConfirmDetails />
              </ProtectedRoute>
            ),
            loader: confirmDetailsLoader,
            path: 'confirm-details',
          },
          {
            element: (
              <ProtectedRoute requireReferral>
                <MoreInformation />
              </ProtectedRoute>
            ),
            path: 'more-information',
          },
          {
            action: createAppointmentAction,
            element: (
              <ProtectedRoute requireReferral>
                <ProposedAppointment />
              </ProtectedRoute>
            ),
            loader: proposedAppointmentLoader,
            path: 'proposed-appointment',
          },
          {
            action: createAppointmentAction,
            element: (
              <ProtectedRoute requireReferral>
                <AutomaticBooking />
              </ProtectedRoute>
            ),
            path: 'automatic-booking',
          },
          {
            children: [
              {
                element: <SelectClinic />,
                loader: selectClinicLoader,
                path: 'select-clinic',
              },
              {
                element: <SelectDateTime />,
                loader: selectDateTimeLoader,
                path: 'select-date-time',
              },
              {
                action: createAppointmentAction,
                element: <ConfirmBooking />,
                path: 'confirm-booking',
              },
            ],
            element: (
              <ProtectedRoute requireReferral>
                <Outlet />
              </ProtectedRoute>
            ),
            path: 'manual-booking',
          },
          {
            element: <ReferralNotFound />,
            path: 'not-found',
          },
        ],
        element: <Outlet />,
        path: 'referral',
      },
      {
        element: (
          <ProtectedRoute requireReferral>
            <SuccessScreen />
          </ProtectedRoute>
        ),
        path: 'success',
      },
      {
        element: (
          <ProtectedRoute requireReferral>
            <ErrorScreen />
          </ProtectedRoute>
        ),
        path: 'error',
      },
    ],
    element: <App />,
    path: '*',
  },
]
